
import Services from './base-services'

const service = new Services('job-types')

export default {
  listFromSuite: () => {
    return service.suiteOperation(() => service.get('list'))
  }
}
